function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5159 1.29362C12.9117 0.865677 13.5883 0.865678 13.9841 1.29362L14.3719 1.71285C14.7264 2.09613 14.7264 2.68765 14.3719 3.07093L8.2341 9.70638C7.83825 10.1343 7.16175 10.1343 6.7659 9.70638L0.628114 3.07093C0.27358 2.68765 0.27358 2.09613 0.628114 1.71285L1.0159 1.29362C1.41175 0.865677 2.08825 0.865678 2.4841 1.29362L6.7659 5.9226C7.16175 6.35054 7.83825 6.35054 8.2341 5.9226L12.5159 1.29362Z",
  fill: "#8A93A6"
});

var SvgSelectDown = function SvgSelectDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/select-down.09723102.svg";
export { ForwardRef as ReactComponent };